import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Class names merged the Tailwind way: later utilities win over earlier ones of the same kind. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
